<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <el-breadcrumb-item v-for="item in breadcrumbItems" :key="item.key">
      <button
        v-if="item.clickable"
        class="breadcrumb-link"
        type="button"
        @click="goParent(item)"
      >
        {{ item.title }}
      </button>
      <span v-else class="breadcrumb-current">{{ item.title }}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {setNavigationSource, requestPageStateRestore} from '@/utils/pageNavigation'

export default {
  name: 'Breadcrumb',
  computed: {
    ...mapGetters([
      'breadcrumbParent'
    ]),
    breadcrumbItems() {
      const current = {
        key: `current-${this.$route.name || this.$route.path}`,
        title: this.$route.meta && this.$route.meta.title
          ? this.$route.meta.title
          : '',
        clickable: false
      }

      if (!this.$route.meta || !this.$route.meta.detailPage) {
        return current.title ? [current] : []
      }

      const parent = this.getParentItem()
      return parent ? [parent, current] : [current]
    }
  },
  methods: {
    getParentItem() {
      const storedParent = this.breadcrumbParent
      if (storedParent && storedParent.detailRouteName === this.$route.name) {
        return Object.assign({}, storedParent, {
          key: `parent-${storedParent.name || storedParent.path}`,
          clickable: true
        })
      }

      const parentName = this.$route.meta && this.$route.meta.defaultParentName
      if (!parentName) return null

      const resolved = this.$router.resolve({name: parentName}).route
      if (!resolved || !resolved.name) return null

      return {
        key: `parent-${resolved.name}`,
        name: resolved.name,
        path: resolved.path,
        fullPath: resolved.fullPath,
        title: resolved.meta && resolved.meta.title ? resolved.meta.title : '',
        clickable: true
      }
    },
    goParent(item) {
      const parentRoute = this.$router.resolve(item.fullPath || {name: item.name}).route
      requestPageStateRestore(parentRoute)
      setNavigationSource('breadcrumb')
      if (item.fullPath) {
        this.$router.push(item.fullPath)
        return
      }
      this.$router.push({name: item.name})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  min-width: 0;
  font-size: 14px;

  /deep/ .el-breadcrumb__inner,
  /deep/ .el-breadcrumb__separator {
    color: #64748b;
    //font-weight: 600;
  }

  /deep/ .el-breadcrumb__separator {
    margin: 0 8px;
    color: #63748b;
  }

  .breadcrumb-link {
    padding: 0;
    border: none;
    background: transparent;
    color: #64748b;
    font: inherit;
    //font-weight: 600;
    cursor: pointer;

    &:hover {
      color: #ff7d3f;
    }
  }

  .breadcrumb-current {
    color: #64748b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue